export enum PartTreeSearchActionType {
  INIT_SEARCH = "INIT_TREE_SEARCH",
  SUBMIT_SEARCH = "SUBMIT_TREE_SEARCH",
  CHANGE_PAGE = "CHANGE_TREE_SEARCH_PAGE",
  CHANGE_PAGE_SIZE = "CHANGE_TREE_SEARCH_PAGE_SIZE",
  CHANGE_SORT = "CHANGE_TREE_SEARCH_SORT",
  CHANGE_SORT_CARDS_VIEW = "CHANGE_TREE_SEARCH_SORT_CARDS_VIEW",
  FETCH_RESULTS = "FETCH_TREE_MATS",
  FETCH_RESULTS_START = "FETCH_TREE_MATS_START",
  FETCH_RESULTS_SUCCESS = "FETCH_TREE_MATS_SUCCESS",
  FETCH_RESULTS_FAIL = "FETCH_TREE_MATS_FAIL"
}

export const PAGE_SIZE_OPTIONS = [12, 24, 36, 48];
